<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form" class="dynamic-form">
    @for (field of data.fields; track field) {
      <!--Switch case según el type del input-->
      @switch (field.type) {
        <!--Input de texto-->
        @case ('text') {
          <ng-container *ngTemplateOutlet="inputTemplate; context: { field: field, type: 'text' }"> <!--Usar ngTemplateOutlet permite usar el mismo input para texto y numeros-->
          </ng-container>
        }
        <!--Input de etiquetas-->
        @case ('rfid') {
          <ng-container *ngTemplateOutlet="inputTemplate; context: { field: field, type: 'text' }"> <!--Usar ngTemplateOutlet permite usar el mismo input para texto y numeros-->
          </ng-container>
        }
        <!--Input de numero-->
        @case ('number') {
          <ng-container *ngTemplateOutlet="inputTemplate; context: { field: field, type: 'number' }"> <!--Usar ngTemplateOutlet permite usar el mismo input para texto y numeros-->
          </ng-container>
        }
        <!--Input de correo-->
        @case ('email') {
          <ng-container *ngTemplateOutlet="inputTemplate; context: { field: field, type: 'email' }"> <!--Usar ngTemplateOutlet permite usar el mismo input para texto y numeros-->
          </ng-container>
        }
        <!--Selector-->
        @case ('select') {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [formControlName]="field.key">
              @for (opt of field.options; track opt) {
                <mat-option [value]="opt.value">
                  {{ opt.label }}
                </mat-option>
              }
            </mat-select>
            @if (form.get(field.key)?.hasError('required')) {<mat-error>
                Este campo es requerido
              </mat-error>}
          </mat-form-field>
        }
        <!--Selector mútliple-->
        @case ('multiselect') {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>{{ field.label }}</mat-label>
            <mat-select [formControlName]="field.key" multiple>
              <mat-option class="select-all-option" value="all">
                <mat-checkbox [checked]="isAllCheck(field)" [indeterminate]="isSomeChecked(field)"
                  (click)="$event.stopPropagation(); CheckAll(field)">
                  Seleccionar Todo
                </mat-checkbox>
              </mat-option>
              @for (opt of field.options; track opt) {
                <mat-option [value]="opt.value"> {{ opt.label }}</mat-option>
              }
            </mat-select>
            @if (form.get(field.key)?.hasError('required')) {<mat-error>
                Este campo es requerido
              </mat-error>}
          </mat-form-field>
        }
        <!--Autocomplete-->
        @case ('autocomplete') {
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>{{ field.label }}</mat-label>
            <input type="text" placeholder="Seleccione" [aria-label]="field.label" matInput
              [formControlName]="field.key"
              [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="fixAutocomplete(field.options)">
              @for (opt of field.options; track opt) {
                <mat-option [value]="opt.value">
                  {{ opt.label }}
                </mat-option>
              }
            </mat-autocomplete>
            @if (form.get(field.key)?.hasError('required')) {<mat-error>
                Este campo es requerido
              </mat-error>}
          </mat-form-field>
        }
        <!--Radio-->
        @case ('radio') {
          <mat-form-field>
            <mat-label>{{field.label}}</mat-label>
            <mat-radio-group>
              @for (opt of field.options; track opt) {
                <mat-radio-button [value]="opt.value">
                  {{ opt.label }}
                </mat-radio-button>
              }
            </mat-radio-group>
            @if (form.get(field.key)?.hasError('required')) {<mat-error>
                Este campo es requerido
              </mat-error>}
          </mat-form-field>
        }
        <!--Fecha-->
        @case ('date') {
          <mat-form-field appearance="outline" class="half-width">
            <mat-label>{{ field.label }}</mat-label>
            <input matInput [matDatepicker]="picker" [formControlName]="field.key">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            @if (form.get(field.key)?.hasError('required')) {<mat-error>
                Este campo es requerido
              </mat-error>}
          </mat-form-field>
        }
        <!--Botón-->
        @case ('button') {
          <div class="button-container" style="margin-bottom: 1rem;">
            <button mat-raised-button color="accent" type="button" [matTooltip]="field.label" (click)="onActionClick(field.action)">
              <mat-icon>{{ field.icon }}</mat-icon>
            </button>
          </div>
        }
        <!--Tabla con información-->
        @case ('table') {
          <div class="table-container">
            <h3>{{ field.label }}</h3>
            <table mat-table [dataSource]="field.tableConfig?.data || []" class="mat-elevation-z2">
              @for (col of field.tableConfig?.columns; track col) {
                <ng-container [matColumnDef]="col">
                  <th mat-header-cell *matHeaderCellDef> {{ col | titlecase }} </th>
                  <td mat-cell *matCellDef="let element"> {{ element[col] }} </td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="field.tableConfig?.columns"></tr>
              <tr mat-row *matRowDef="let row; columns: field.tableConfig?.columns;"></tr>
            </table>
          </div>
        }
      }
    }

    <!--Template dinámico para texto, números, emails, para no tener que repetir código-->
    <ng-template #inputTemplate let-field="field" let-type="type">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ fieldLabel(field) }}</mat-label>
        <input matInput [type]="type" [formControlName]="field.key" [attr.maxlength]="field.type === 'rfid' ? 24 : null" [attr.minlength]="field.type === 'rfid' ? 24 : null" [attr.placeholder]="field.type === 'rfid' ? '24 caracteres' : null">
        @if (field.type === 'rfid') {
          <mat-hint align="end">{{ (form.get(field.key)?.value || '').length }}/24</mat-hint>
          @if (form.get(field.key)?.hasError('minlength') || form.get(field.key)?.hasError('maxlength')) {<mat-error>La etiqueta debe tener 24 caracteres</mat-error>}
        }
        @if (form.get(field.key)?.hasError('required')) {<mat-error>
            Este campo es requerido
          </mat-error>}
      </mat-form-field>
    </ng-template>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="form.invalid"> Aceptar</button>
</mat-dialog-actions>